import { Marker } from '@vis.gl/react-google-maps';
import { DeliveryBoardItem } from 'views/delivery-board/types/delivery-board-model.type';
import React from 'react';
import vesselIcon from '../assets/vessel.svg';

type Props = { data: DeliveryBoardItem; onClick: (e: google.maps.MapMouseEvent) => void; activeMarker: string };

const VesselMarker: React.FC<Props> = ({ data, onClick, activeMarker }) => {
  return (
    <Marker
      title={data.vessel}
      icon={{
        url: vesselIcon,
        size: new google.maps.Size(32, 38),
        scaledSize: new google.maps.Size(32, 38),
        labelOrigin: new google.maps.Point(15, -11),
      }}
      zIndex={20}
      key={data.distributionId}
      position={{ lat: Number(data.vesselLocation.latitude), lng: Number(data.vesselLocation.longitude) }}
      opacity={activeMarker === '' ? 1 : activeMarker === data.distributionId ? 1 : 0.6}
      onClick={onClick}
      label={{ text: `${data.vessel}`, color: '#fff', fontSize: '16px', fontWeight: '400' }}
    />
  );
};

export default React.memo(VesselMarker);
